import { Typography } from "@mui/material";

interface Props {
  message: string;
}

function UserChat(props: Props) {
  const { message } = props;

  return (
    <div
      style={{
        display: "flex",
        margin: "10px",
        gap: "5px",
        flexDirection: "row-reverse",
        paddingTop: "10px",
      }}
    >
      <Typography
        style={{
          backgroundColor: "rgb(26, 32, 44)",
          maxWidth: "65%",
          padding: 15,
          borderRadius: "8px",
          color: "white",
        }}
      >
        {message}
      </Typography>
    </div>
  );
}

export default UserChat;
